import script from "./ContractInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContractInfo.vue?vue&type=script&setup=true&lang=ts"

import "./ContractInfo.vue?vue&type=style&index=0&id=d315fd04&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d315fd04"]])

export default __exports__